import React, { useState } from 'react'
import { User } from '../../types/User'
import { useUser } from '../../redux/slices/userSlice'
import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { ToastActions } from '../../redux/slices/toastSlice'
import { useDispatch } from 'react-redux'
import { Suggestion } from '../../types/Suggestion'
import { addDoc, collection } from 'firebase/firestore'
import { dbService } from '../../utils/fbase'
import { getSuggestionCollectionId } from '../../utils/dbUtils'
import { makeShort } from '../../utils/stringUtils'
import { useHistory } from 'react-router-dom'

export default function SuggestionCreation(): JSX.Element {
  const user: User | null | undefined = useUser()
  const theme = useTheme()
  const matchesSM: boolean = useMediaQuery(theme.breakpoints.down('sm'))
  const [text, setText] = useState<string>('')
  const dispatch = useDispatch()
  const history = useHistory()
  const addSuggestion = () => {
    if (!user) {
      return
    }

    if (text.length === 0) {
      dispatch(
        ToastActions.openDialog({
          title: 'Fill out your suggestion.',
        })
      )
      return
    }

    const now: number = new Date().getTime()
    const suggestion: Suggestion = {
      text,
      author: {
        displayName: user.name,
        thumb: user.photoUrl,
      },
      timestamp: now,
      userId: user.id,
      views: 0,
      likes: 0,
      comments: 0,
      isConfirmed: false,
    }
    const docRef = addDoc(
      collection(dbService, getSuggestionCollectionId()),
      suggestion
    )

    docRef
      .then((data) => {
        history.push(`/suggestion/${data.id}`)
        dispatch(
          ToastActions.set({
            text: `${makeShort(
              text,
              10
            )} has been added. We will reply your suggestion.`,
          })
        )
      })
      .catch((error) => console.error(error))
  }

  const getBoxProps = () => {
    return {
      pl: matchesSM ? 1 : 2,
      pr: matchesSM ? 1 : 2,
      pb: 2,
    }
  }

  return (
    <>
      <Paper square>
        <Box p={matchesSM ? 2 : 4}>
          <Typography variant="h6">Add Suggestion</Typography>
        </Box>
      </Paper>
      <Paper square>
        <Box {...getBoxProps()}>
          <TextField
            label="여러분의 의견으로 앱이 개선됩니다."
            multiline={true}
            rows={4}
            fullWidth={true}
            variant="outlined"
            value={text}
            onChange={(e) => setText(e.currentTarget.value)}
          />
        </Box>
        <Box {...getBoxProps()}>
          <Grid container={true} justifyContent={'flex-start'}>
            <Button variant="contained" color="primary" onClick={addSuggestion}>
              ADD
            </Button>
          </Grid>
        </Box>
      </Paper>
    </>
  )
}
